var React = require('react');

function ContentInfoClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25 .16C11.269.16.16 11.269.16 25S11.269 49.84 25 49.84 49.84 38.731 49.84 25 38.731.16 25 .16zm8.556 31.464c.552.552.552 1.38 0 1.932a1.362 1.362 0 0 1-.966.414c-.345 0-.69-.138-.966-.414L25 26.932l-6.624 6.624a1.362 1.362 0 0 1-.966.414c-.345 0-.69-.138-.966-.414a1.334 1.334 0 0 1 0-1.932L23.068 25l-6.624-6.624a1.334 1.334 0 0 1 0-1.932 1.334 1.334 0 0 1 1.932 0L25 23.068l6.624-6.624a1.334 1.334 0 0 1 1.932 0c.552.552.552 1.38 0 1.932L26.932 25l6.624 6.624z","fillRule":"nonzero"}));
}

ContentInfoClose.defaultProps = {"role":"presentation","viewBox":"0 0 50 50"};

module.exports = ContentInfoClose;

ContentInfoClose.default = ContentInfoClose;
